export default [
    {
        path: "/voucher/canteen/transaction/sync",
        component: () => import("@/App/Canteen/Voucher/Sync/Components/DayBook.vue"),
        name: "voucher-canteen-transaction-sync",
        meta: {
            requiresAuth: true,
        },
    },
];
